import React, {Component} from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import id from "@irati/utils/id"
import connect from "@irati/store/connect"
import {greys, perkbox} from "@irati/ui/src/global/colors"
import {FormattedMessage} from "@irati/utils/lang"

import Bar from "./Bar"
import DefaultStepRenderer from "./DefaultStepRenderer"


const Wrapper = styled.div`
  display: flex;
  justify-content: ${({isMobile}) => (isMobile ? "center" : "space-between")};
  position: relative;
`


const MobileLabel = styled.div`
  color: ${greys.medium};
  text-transform: uppercase;
  text-align: center;
  font-size: 10px;
  line-height: 15px;
`


class StepIndicator extends Component {
  static propTypes = {
    mq: PropTypes.object.isRequired,
    renderer: PropTypes.any,
    steps: PropTypes.array.isRequired,
    activeStep: PropTypes.number.isRequired,
    barColor: PropTypes.string,
    activeBarColor: PropTypes.string,
    className: PropTypes.string
  }
  static defaultProps = {
    renderer: DefaultStepRenderer,
    barColor: greys.light,
    activeBarColor: perkbox.blue,
    className: null
  }

  render() {
    const idNamespace = id("StepIndicator", this.props)
    const {steps, activeStep, renderer, barColor, activeBarColor, className} = this.props
    const StepRenderer = renderer
    const totalSteps = steps.length
    const isMobile = this.props.mq.lessThan.medium || totalSteps > 10

    return (
      <Wrapper isMobile={isMobile} className={className}>

        {isMobile && (
          <MobileLabel>
            <FormattedMessage id="insights.ui.stepIndicator.mobileLabel" values={{activeStep, totalSteps}} />
          </MobileLabel>
        )}

        {!isMobile && (
          <Bar
            id={idNamespace}
            activeColor={activeBarColor}
            color={barColor}
            progressPercentage={((activeStep - 1) / (totalSteps - 1)) * 100} />
        )}

        {!isMobile && steps.map((step, index) => (
          <StepRenderer key={index} id={id(index, idNamespace)} index={index} activeStep={activeStep} step={step} />
        ))}

      </Wrapper>
    )
  }
}

const mapStateToProps = ({mq}) => ({mq})

export default connect(mapStateToProps)(StepIndicator)
